import ReadMore from "@stimulus-components/read-more"

// Connects to data-controller="read-more"
export default class extends ReadMore {
  connect() {
    super.connect();

    const isOverflowing = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) => {
      return scrollHeight > clientHeight || scrollWidth > clientWidth;
    }
    if (isOverflowing(this.contentTarget)) {
      this.contentTarget.nextElementSibling.classList.remove("hidden");
    }
  }

  show(event) {
    this.open = true;

    const toggleButton = this.contentTarget.nextElementSibling;
    if (toggleButton) {
      toggleButton.innerHTML = this.lessTextValue;
    }

    this.contentTarget.classList.remove("line-clamp-2");
    this.contentTarget.classList.add("line-clamp-none");
  }

  hide(event) {
    this.open = false;

    const toggleButton = this.contentTarget.nextElementSibling;
    if (toggleButton) {
      toggleButton.innerHTML = this.moreTextValue;
    }

    this.contentTarget.classList.add("line-clamp-2");
    this.contentTarget.classList.remove("line-clamp-none");
  }
}
